import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'demo-navigation',
    templateUrl: './demo-navigation.html',
    styleUrls: ['./demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoNavigationComponent {
    selectedTab = 'home';

    tabs = [
        { name: 'home', label: 'Home', icon: 'home-outline' },
        { name: 'search', label: 'Search', icon: 'search-outline' },
        { name: 'cart', label: 'Cart', icon: 'cart-outline' },
        { name: 'profile', label: 'Profile', icon: 'person-outline' },
    ];

    constructor(private change: ChangeDetectorRef) {
    }

    onTabSelected(tabName: string) {
        this.selectedTab = tabName;
        this.change.markForCheck();
    }

    selectTab(name: string) {
        this.selectedTab = name;
        this.change.markForCheck();
    }
}
